import * as React from 'react';
import { ResponsiveLine } from '@nivo/line';
import { ToastContainer, toast } from 'react-toastify';
import { CircularProgressbar } from 'react-circular-progressbar';

import { DailyGoalContainer, GoalWrapper, GraphWrapper, GoalHeader } from './DailyGoal.styles';
// import { determineFill } from '../../../../common/services';
import { number } from 'prop-types';

const weekdays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

export default class DailyGoal extends React.Component {
    ls = window.localStorage;
    constructor(props) {
        super(props);
        this.state = {
            dailyGoal: number,
            modalOpen: false,
            today: number
        }
    }
  async componentDidMount() {
        const goal = this.ls.getItem("dailygoal");
        if(goal !== null) {
            const dailyGoal = parseInt(goal, 10);
            this.setState({dailyGoal});
        }else {
            toast.info("Daily Goal Not Set!");
        }
        const dailyGoal = parseInt(this.ls.getItem('dailygoal'), 10);
        const today = parseInt(this.ls.getItem(weekdays[new Date().getDay()]), 10);
        this.setState({dailyGoal, today});
    }
    determineFill(value) {
      if(value >= 0 && value <= 20) {
         return "#e7233d";
      }
      else if(value >20 && value <=40) {
          return "#8e0666";
      }
      else if(value> 40 && value <= 60){
          return "#f56f3f";
      }
      else if(value > 60 && value <= 80){
        return "#feb743";
      }
      else if(value > 80 && value <= 100){
          return "#18ee97";
      }
      else {
          return "#000";
      }
    }


  render() {
        const dailyGoal = parseInt(this.ls.getItem('dailygoal'), 10);
        const today = parseInt(this.ls.getItem(weekdays[new Date().getDay()]), 10);
        console.log(`currentVals: ${dailyGoal} and ${today}`);
        const text = Math.round((today/dailyGoal) * 100);
        const data = this.props.data;
        return(
            <DailyGoalContainer>
              <ToastContainer/>
                <GoalHeader>
                <h1 className="daily-goal">Daily Goal</h1>
                <h1 className="edit-goal" onClick={this.props.editGoal}>Edit Goal</h1>
                </GoalHeader>
                <GoalWrapper>
                    <div className="goal-donut">
                        <CircularProgressbar
                          value={Math.round((today/dailyGoal) * 100)}
                          text = {text + "%"}
                          styles={{
                            path: {
                              stroke: this.determineFill(text),
                              strokeLinecap: 'round',
                              transition: 'stroke-dashoffset 0.5s ease 0s',
                              transformOrigin: 'center center',
                            },trail: {
                              stroke: '#000',
                              strokeLinecap: 'butt',
                              // transform: 'rotate(0.25turn)',
                              transformOrigin: 'center center',
                            },
                            text: {
                             fill: this.determineFill(text),
                              fontSize: '16px',
                            }
                          }}
                          />
                        <p>Completed</p>
                    </div>
                    <div className="goal">
                      <p className="daily-goal"> <span>Goal</span><br/>{today}/{dailyGoal}<br/><span> Mins</span></p>
                    </div>
                </GoalWrapper>
                <GraphWrapper>
                    <ResponsiveLine
                                data={data}
                                margin={{ top: 20, right: 20, bottom: 50, left: 30 }}
                                xScale={{ type: 'point' }}
                                yScale={{ type: 'linear', stacked: false, min: 0, max: 80 }}
                                axisTop={null}
                                axisRight={null}
                                axis = {{
                                    fontSize: "14px",
                                    tickColor: "#fa96a5",
                                    fontWeight: 'bold'
                                }}
                                axisBottom={{
                                    orient: 'bottom',
                                    tickSize: 2,
                                    tickPadding: 5,
                                    tickRotation: 0,
                                    color: '#fff',
                                    legendOffset: 30,
                                    legendPosition: 'middle'
                                }}
                                axisLeft={{
                                    orient: 'left',
                                    tickSize: 2,
                                    tickPadding: 5,
                                    tickRotation: 0,
                                    legendOffset: -50,
                                    legendPosition: 'middle',
                                    tickValues: [20, 40, 60, 80]
                                }}
                                colors={'#08e666'}
                                pointSize={14}
                                pointColor={'#95f0c5'}
                                pointBorderWidth={2}
                                pointBorderColor={{ from: 'serieColor' }}
                                pointLabel="y"
                                pointLabelYOffset={-12}
                                useMesh={false}
                                isInteractive={true}
                                enableSlices = 'x'
                                enableArea={true}
                                areaOpacity={0.05}
                                enableGridX={false}
                                theme={{
                                    axis: {
                                      fontSize: "14px",
                                      tickColor: "#eee",
                                      ticks: {
                                        line: {
                                          stroke: "#e7233d"
                                        },
                                        text: {
                                          fill: "#ffffff"
                                        }
                                      },
                                      legend: {
                                        text: {
                                          fill: "#aaaaaa",
                                          fontFamily: "Roboto Condensed",
                                          fontWeight: 'bold'
                                        }
                                      }
                                    },
                                    grid: {
                                      line: {
                                        stroke: "#777"
                                      }
                                    }
                                  }}
                                tooltip = {(e) => {
                                      return(
                                        <div
                                        style={{
                                            background: '#08e666',
                                            padding: '9px 12px',
                                            borderRadius: '5px',
                                          }}>
                                            <div
                                                style={{
                                                backgroundColor: '#08e666',
                                                color: "#000",
                                                padding: '3px 0',
                                                fontSize: "14px"
                                                }}
                                                >
                                                <strong>Achieved</strong> {e.point.data.yFormatted} <strong>Mins</strong>
                                            </div>
                                        </div>
                                      )
                                  }}
                                  to

                                // onClick = {this.handleMouseClick}
                    />
                </GraphWrapper>
            </DailyGoalContainer>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/OnBoard/Plexing/DailyGoal/DailyGoal.Component.jsx